import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { id: "options" }
const _hoisted_2 = { class: "map-pane" }
const _hoisted_3 = { class: "map-info" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "map-text" }
const _hoisted_6 = { class: "map-level-box" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "遭遇战通关进度", -1)
const _hoisted_8 = { class: "map-step-bar" }
const _hoisted_9 = { class: "step-options" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "map-chest-box" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, "隐藏箱进度", -1)
const _hoisted_14 = { class: "chest-step-bar" }
const _hoisted_15 = { class: "step-options" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "options-pane" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "map-list-box" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["src", "alt"]
const _hoisted_22 = { class: "map-confirm-box" }
const _hoisted_23 = { class: "money-input-box" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { for: "money" }, "输入货币数量：", -1)
const _hoisted_25 = { class: "buttons" }
const _hoisted_26 = { class: "card-input-box" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { for: "card" }, "输入抽卡次数：", -1)
const _hoisted_28 = { class: "buttons" }

import {
  maps,
  mapName,
  mapDialogVisible,
  moneyDialogVisible,
  cardDialogVisible,
  moneyInputRef,
  cardInputRef,
  mapDoorButtonDisabled,
  mapNextButtonDisabled,
  chestNextButtonDisabled,
  flawlessButtonDisabled,
  mapSteps,
  mapStepNum,
  mapStepWidth,
  chestSteps,
  chestStepNum,
  chestStepWidth,
  setMap,
  mapDoor,
  mapNext,
  nextChest,
  setMoney,
  setDrawCount,
  flawlessButton,
  initOptions
} from "@/assets/ts/options";


export default /*#__PURE__*/_defineComponent({
  __name: 'OptionsView',
  setup(__props) {

initOptions();

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "map-img",
          src: require('@/assets/images/maps/raid/' + _unref(mapName) +'.jpg'),
          alt: "地图"
        }, null, 8, _hoisted_4),
        _createElementVNode("p", _hoisted_5, "- " + _toDisplayString(_unref(mapName)) + " -", 1),
        _createElementVNode("button", {
          class: "button map-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (mapDialogVisible.value = true))
        }, "选择地图")
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: "map-bar",
            style: _normalizeStyle({'width': ((_unref(mapStepNum) - 1) * _unref(mapStepWidth)) + '%'})
          }, null, 4),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_unref(mapSteps) + 1), (index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["step map-step", { 'active': index >= 1 }]),
              key: index
            }, _toDisplayString(index - 1), 3))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "button",
            id: "map-door",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(mapDoor) && _unref(mapDoor)(...args))),
            disabled: _unref(mapDoorButtonDisabled)
          }, "抵达遭遇战插旗点（再点这个） ", 8, _hoisted_10),
          _createElementVNode("button", {
            class: "button",
            id: "map-next",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(mapNext) && _unref(mapNext)(...args))),
            disabled: _unref(mapNextButtonDisabled)
          }, "遭遇战完成（先点这个） ", 8, _hoisted_11)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", {
            class: "chest-bar",
            style: _normalizeStyle({'width': ((_unref(chestStepNum) - 1) * _unref(chestStepWidth)) + '%'})
          }, null, 4),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_unref(chestSteps) + 1), (index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["step map-step", { 'active': index >= 1 }]),
              key: index
            }, _toDisplayString(index - 1), 3))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("button", {
            class: "button",
            id: "chest-next",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(nextChest) && _unref(nextChest)(...args))),
            disabled: _unref(chestNextButtonDisabled)
          }, "已获取隐藏箱 ", 8, _hoisted_16)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("button", {
        class: "button",
        id: "money-button",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (moneyDialogVisible.value = true))
      }, "设置货币数量"),
      _createElementVNode("button", {
        class: "button",
        id: "card-button",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (cardDialogVisible.value = true))
      }, "设置抽卡次数"),
      _createElementVNode("button", {
        class: "button",
        id: "flawless",
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_unref(flawlessButton) && _unref(flawlessButton)(...args))),
        disabled: _unref(flawlessButtonDisabled)
      }, "无暇通关（加 6 货币） ", 8, _hoisted_18)
    ]),
    _createVNode(_component_el_dialog, {
      class: "dialog map-dialog",
      modelValue: _unref(mapDialogVisible),
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(mapDialogVisible) ? (mapDialogVisible).value = $event : null)),
      "close-on-click-modal": false,
      width: "75rem",
      "align-center": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_19, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(maps), (map, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "map-item",
              key: index,
              onClick: ($event: any) => (_unref(setMap)(map))
            }, [
              _createElementVNode("img", {
                src: require('@/assets/images/maps/raid/' + map.name + '.jpg'),
                alt: map.name
              }, null, 8, _hoisted_21),
              _createElementVNode("p", null, _toDisplayString(map.name), 1)
            ], 8, _hoisted_20))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("button", {
            type: "button",
            class: "button map-cancel",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (mapDialogVisible.value = false))
          }, "取消")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      class: "dialog money-dialog",
      modelValue: _unref(moneyDialogVisible),
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_isRef(moneyDialogVisible) ? (moneyDialogVisible).value = $event : null)),
      "close-on-click-modal": false,
      width: "25rem",
      "align-center": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createVNode(_component_el_input, {
            type: "text",
            id: "money",
            modelValue: _unref(moneyInputRef),
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(moneyInputRef) ? (moneyInputRef).value = $event : null))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("button", {
            type: "button",
            class: "button money-confirm",
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_unref(setMoney) && _unref(setMoney)(...args)))
          }, "确认"),
          _createElementVNode("button", {
            type: "button",
            class: "button money-cancel",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (moneyDialogVisible.value = false))
          }, "取消")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      class: "dialog card-dialog",
      modelValue: _unref(cardDialogVisible),
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_isRef(cardDialogVisible) ? (cardDialogVisible).value = $event : null)),
      "close-on-click-modal": false,
      width: "25rem",
      "align-center": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createVNode(_component_el_input, {
            type: "text",
            id: "card",
            modelValue: _unref(cardInputRef),
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_isRef(cardInputRef) ? (cardInputRef).value = $event : null))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("button", {
            type: "button",
            class: "button card-confirm",
            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_unref(setDrawCount) && _unref(setDrawCount)(...args)))
          }, "确认"),
          _createElementVNode("button", {
            type: "button",
            class: "button card-cancel",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (cardDialogVisible.value = false))
          }, "取消")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})